import React from 'react'
import styled from '@emotion/styled'
const StyledAboutContainer = styled('div')`
    margin: 8rem auto;
    width:90vw;
    color: rgb(50, 20, 93);
    padding: 2rem;
    border-radius: 3px;
    background-color: white;
    box-shadow: 0px 10px 20px rgb(0 0 0 / 20%), -20px 40px 0 #e05c32,
        20px -40px 0 #e57754;
    @media (max-width: 800px) {
        box-shadow: none;
    }
    & .flexAround {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
    }
    & h2 {
        text-align: center;
        color: rgb(50, 20, 93);
    }
    & h1 {
        color: rgb(50, 20, 93);
    }
    & ul {
        list-style: none;
    }
`
const iconStyle = {
    height: '2rem',
    width: '2rem',
    fill: '#e88565',
    marginRight: '2rem',
}
const StyledColumnFlex = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
`
const WhereContainer = styled('div')`
    padding: 0px 2rem;
    border-right: 1px solid rgba(0, 0, 0, 0.3);
    &:last-of-type {
        border: none;
    }
    @media (max-width: 800px) {
        border: none;
    }
`
const StyledSedonaImage = styled('img')`
    height: 100%;
`

const HeaderContainer = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
`

const About = () => {
    return (
        <StyledAboutContainer>
            <StyledColumnFlex>
                <h1>Where...</h1>
                <span className="flexAround">
                    <WhereContainer>
                        <HeaderContainer>
                            <svg style={iconStyle}>
                                <use xlinkHref="img/sprite.svg#icon-place" />
                            </svg>
                            <h2>I've been</h2>
                        </HeaderContainer>
                        <ul>
                            <li>Architect React with Typescript</li>
                            <li>Maintainence and debugging Java/Kotlin</li>
                            <li>Basic queries with Sql</li>
                            <li>Frontend testing with Jest and Testing library </li>
                            <li>e2e testing with Cucumber and Selenium </li>
                        </ul>
                    </WhereContainer>
                    <WhereContainer>
                        <HeaderContainer>
                            <svg style={iconStyle}>
                                <use xlinkHref="img/sprite.svg#icon-shuffle" />
                            </svg>
                            <h2>I thrive</h2>
                        </HeaderContainer>
                        <ul>
                            <li>Collaborating with product and design</li>
                            <li>Clear achievable deadlines</li>
                            <li>Honest and open feedback loops</li>
                        </ul>
                    </WhereContainer>
                </span>
            </StyledColumnFlex>
        </StyledAboutContainer>
    )
}
export default About



// WEBPACK FOOTER //
// ./src/components/About.js